export enum HistoryTableStatusEnum {
  Copied = 'Copied',
  NotCopied = 'Not Copied',
}
